import axios from './providers/axios';

const marketplaceService = {
    store(params = {}) {
        return axios.get(`/v1/admin/marketplace/store`, {params})
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    myProduct(params = {}) {
        return axios.get(`/v1/admin/marketplace/myProducts`, {params})
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    pendingProducts(params = {}) {
        return axios.get(`/v1/admin/marketplace/pendingProducts`, {params})
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    add(data) {
        return axios.post(`/v1/admin/marketplace/add`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    update(data) {
        return axios.post(`/v1/admin/marketplace/update`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    delete(id) {
        return axios.delete(`/v1/admin/marketplace/delete/${id}`)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    getStats() {
        return axios.get(`/v1/admin/marketplace/statistics`)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    getFromId(id) {
        return axios.get(`/v1/admin/marketplace/getFromId/${id}`)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    approveItem(id) {
        return axios.put(`/v1/admin/marketplace/approve/${id}`)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    rejectItem(id, data) {
        return axios.put(`/v1/admin/marketplace/reject/${id}`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    getSimilarProducts(productId) {
        return axios.post(`/v1/admin/marketplace/getSimilarProducts`, {
            productId: productId
        }, {
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    purchasedProducts(params = {}) {
        return axios.get(`/v1/admin/marketplace/purchase/myPurchases`, {params})
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    mySales(params = {}) {
        return axios.get(`/v1/admin/marketplace/purchase/mySales`, {params})
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    },
    buyProduct(data) {
        return axios.post(`/v1/admin/marketplace/purchase/buy`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    }
}

export default marketplaceService;
